import type { Motion } from './types';

export const motion: Motion = {
  productive: '150ms cubic-bezier(0.65, 0.05, 0.36, 1)',
  expressive: '350ms cubic-bezier(0.4, 0, 0.2, 1)',
};
